import Page from "components/Page";
import { KPIListProps } from "./KPIs.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const KPIsList = lazyWithRetry(() => import("./KPIsList"));

export default (props: KPIListProps) => (
  <Page>
    <KPIsList {...props} />
  </Page>
);
